module.exports = __webpack_public_path__ + "img/left_150.6fa41ed1.webp";